import * as React from "react";

;
export const Email = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M23.75 3.25H.25v17.214h23.5V3.25zm-22 2.38l10.24 8.778 9.286-7.628-.952-1.16-8.314 6.83-8.983-7.7H22.25v14.214H1.75V5.631z" fill="#100722" /></svg>;